import { get } from '../../../../helpers/fetch';
import { buildURL } from '../../../../helpers/urls';

// eslint-disable-next-line import/prefer-default-export
export const getMappingInfo = () => {
  const url = buildURL('events', process.env.BRIZI_APP_SLUG, '/configs/queue');
  return get(url);
};
